@if (
    {
        value: vm$ | async,
    };
    as vm
) {
    <medpace-editable-card
        [mode]="mode"
        [title]="'Active CRCs Information'"
        [showTitleAsteriskWhenEditMode]="true"
        [showSwitchModeButton]="false"
        [isLoading]="!vm.value"
        class="o-grid"
    >
        @if (vm.value) {
            <medpace-editable-card-view-mode-content>
                <div class="o-grid">
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            <div class="c-info__block">
                                <h5>Primary CRC:</h5>
                            </div>
                        </div>
                    </div>
                    @if (vm.value.primaryCRC) {
                        <ng-container
                            [ngTemplateOutlet]="CRCInfo_ViewMode"
                            [ngTemplateOutletContext]="{ user: vm.value.primaryCRC }"
                        ></ng-container>
                    } @else {
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <span>This site does not have an active Primary CRC.</span>
                                </div>
                            </div>
                        </div>
                    }
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            <div class="c-info__block">
                                <h5>Supporting CRCs:</h5>
                            </div>
                        </div>
                    </div>
                    @if (vm.value.hasSupportingCRCs) {
                        <div class="supporting-crcs-list">
                            @for (user of vm.value.supportingCRCs; track user; let i = $index) {
                                <ng-container
                                    [ngTemplateOutlet]="CRCInfo_ViewMode"
                                    [ngTemplateOutletContext]="{ user: user }"
                                ></ng-container>
                            }
                        </div>
                    } @else {
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <span>This site does not have any active Supporting CRCs.</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </medpace-editable-card-view-mode-content>
        }
        <ng-template #CRCInfo_ViewMode let-outerUser="user">
            @if (toUser(outerUser); as user) {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="o-grid supporting-crc-info">
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>First/Given Name</h5>
                                        <span>{{ user.firstName }}</span>
                                    </div>
                                </div>
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>Last/Surname</h5>
                                        <span>{{ user.lastName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>Phone Number</h5>
                                        <span>{{ toStringOrFallback(user.phoneNumber, 'Unspecified') }}</span>
                                    </div>
                                </div>
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>Email Address</h5>
                                        <span>{{ toStringOrFallback(user.emailAddress, 'Unspecified') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </ng-template>
    </medpace-editable-card>
}
